import { ShowSection, FormRow } from 'framework/ui/layout';
import { EnumDropdown, InputList, useFormShowContext } from 'framework/form';
import { FloatingButtons } from 'framework/ui/ui-builder';
import { Box, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import ProjectTeamTypeDropdown from './input/ProjectTeamTypeDropdown';
import { PROJECT_TEAM_LOCATION_LABELS } from './constants';
import TeamPositionsInputs from './input/TeamPositionsInputs';

const CreateProjectTeam = () => {
  const { toggleEditMode } = useFormShowContext();

  return (
    <ShowSection>
      <Button onClick={toggleEditMode} sx={{ ml: 0.625, mb: 1.25 }} link>
        ← Back
      </Button>

      <FormRow pr={5.75}>
        <EnumDropdown label="Team location" options={PROJECT_TEAM_LOCATION_LABELS} source="team.location" />

        <ProjectTeamTypeDropdown disabled label="Team type" source="team.type" />
      </FormRow>

      <Box>
        <Typography variant="h6" color="primary" mb={1.25}>
          Team structure
        </Typography>

        <InputList
          inputTemplate={TeamPositionsInputs}
          source="team.expectedStructure"
          addText="Add position"
          maxFields={30}
          defaultValue={{}}
        />
      </Box>

      <FloatingButtons onCancelAction={toggleEditMode} />
    </ShowSection>
  );
};

export default CreateProjectTeam;
